import { wasmModule } from "../wasm/wasmModule"
import {
  treatView,
  viewControlInTreatment,
} from "@/gluelayer"

class ResegmentationModule {
  wasmResegmentationModule = null
  wasmRelabelModule = null
  numberSystem: string = "General"

  async openResegmentationModule(isOpen: boolean) {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) return

    console.log(
      isOpen ? "openResegmentationModule" : "closeResegmentationModule",
    )

    if(!isOpen){
      
      this.wasmResegmentationModule = moduleManager.GetResegmentationModule()
      if (this.wasmResegmentationModule !== null) {
        await new Promise<void>((resolve,reject)=>{
          this.setEmsUpdateResegmentationFinishCallback=()=>{
            resolve();
          }
          this.wasmResegmentationModule.EmsUpdateAfterResegmentation()
        });

        this.setEmsUpdateResegmentationFinishCallback=null;
      }
    }

    
    moduleManager.ToggleResegmentation(isOpen)
    this.wasmResegmentationModule = moduleManager.GetResegmentationModule()

    if (this.wasmResegmentationModule === null) {
      console.log("wasmResegmentationModule is null")
    } else {
      this.wasmResegmentationModule.SetNumberSystem(this.numberSystem)
      console.log("wasmResegmentationModule is not null")
      viewControlInTreatment.zoomWithValueInTreatment(1)// 初次打开模块，重置缩放大小为1
    }
  }

  isResegmentationModuleOpened() {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) {
      return false
    }
    this.wasmResegmentationModule = moduleManager.GetResegmentationModule()
    const opened = this.wasmResegmentationModule !== null
    console.log(`wasmResegmentationModule is ${opened ? "opened" : "closed"}`)
    return opened
  }

  isRelabelModuleOpened() {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) {
      return false
    }
    let isOpen = false
    this.wasmRelabelModule =
      moduleManager.GetToothLabelCorrectionForResegmentationModule()
    if (this.wasmRelabelModule !== null) {
      isOpen = true
       
    }
    return isOpen
  }

  DoNeedRelabel() {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) {
      return false
    }
    let doNeed = false
    this.wasmResegmentationModule = moduleManager.GetResegmentationModule()
    if (this.wasmResegmentationModule !== null) {
      doNeed = this.wasmResegmentationModule.GetDoNeedRelabel()
    }
    return doNeed
  }


  AddATooth(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.AddATooth()   
    }
  }
  
  ConfirmAddTooth(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.ConfirmAddTooth()   
    }
  }

  RemoveATooth(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.RemoveATooth()   
    }
  }

  CancelRemoveTooth(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.CancelRemoveTooth()
    }
  }

  StartPaint(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.StartPaint()
    }
  }

  CancelPaint(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.CancelPaint()
    }
  }

  async CloseRelabel(){
    if(resegmentationModule.isResegmentationModuleOpened()){
      await new Promise<void>((resolve,reject)=>{
        this.setResegmentationRelabelFinishCallback=()=>{
          resolve();
        }
        this.wasmResegmentationModule.CloseRelabel()   
      })
      this.setResegmentationRelabelFinishCallback=null;
    }
  }

  StartDragEdge(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.StartDragEdge()   
    }
  }

  CancelDragEdge(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.CancelDragEdge()   
    }
  }

  Undo(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.Undo()
    }
  }

  CancelOperation(){
    if(resegmentationModule.isResegmentationModuleOpened()){
      switch (resegmentationModule.GetOperateState()) {
        case 6:
          resegmentationModule.CancelPaint()
          break;
        case 9:
          resegmentationModule.CancelRemoveTooth()
          break;
        case 11:
          resegmentationModule.CancelDragEdge()
          break;
        default:
          break;
      }
    }
  }

   GetOperateState() {
   
    let state=-1
    if(resegmentationModule.isResegmentationModuleOpened()){
        state=this.wasmResegmentationModule.GetOperateState()   
    }

    return state
  }

  OperateAddSeedPoint(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.Operate_AddSeedPoint()   
    }
  }

  GotoRelabel(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.GotoRelabel()   
    }
  }

  CancelAndExitRelabel(){
    if(resegmentationModule.isResegmentationModuleOpened()){
        this.wasmResegmentationModule.CancelAndExitRelabel()   
    }
  }


  onResegmentationToIdle = (msg:string) => {

      if(resegmentationModule.SetResegmentationToIdleCB){
        resegmentationModule.SetResegmentationToIdleCB();
      }
  }


  ResetRelabel(){
    if(resegmentationModule.isRelabelModuleOpened()){
        this.wasmResegmentationModule.ResetLabel()   
    }
  }

  IsInResegRelabel(){
    let ret=false
    if(resegmentationModule.isResegmentationModuleOpened()){
        ret=this.wasmResegmentationModule.IsInRelabel()   
    }

    return ret
  }

  GotoManualModel(isManual:boolean){
    if(resegmentationModule.isResegmentationModuleOpened()&&resegmentationModule.isRelabelModuleOpened()){
        this.wasmResegmentationModule.GotoManualModel(isManual)
    }
  }

  IsExistSameLabelForSingleJaw(archType: number) {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) {
      return false
    }
    let isExistSameLabel = false
    this.wasmRelabelModule =
      moduleManager.GetToothLabelCorrectionForResegmentationModule()
    if (this.wasmRelabelModule !== null) {
      isExistSameLabel =
        this.wasmRelabelModule.IsExistSameLabelForSingleJaw(
          archType,
        )
      console.log(
        "wasmToothLabelCorrectionForRelabelModule is opened, IsExistSameLabelForSingleJaw",
        isExistSameLabel,
      )
    }
    return isExistSameLabel
  }


    setGotoResegmentationRelabelCallback?: () => void;

    setResegmentationRelabelFinishCallback?: () => void;

    setResegmentationStatusMsg?: (msg:string) => void;

    SetResegmentationToIdleCB?: () => void;

    setEmsUpdateResegmentationFinishCallback?: () => void;

    SetUpdate2DButtonsPosJsCallBack(callback: (x: number, y: number) => void) {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) return
    this.wasmResegmentationModule = moduleManager.GetResegmentationModule()

    if (!(window as any).resegmentationModule) {
      ;(window as any).resegmentationModule = {}
    }
    ;(window as any).resegmentationModule.SetUpdate2DButtonsPosJsCallBack = callback
    if (this.wasmResegmentationModule != null) {
      this.wasmResegmentationModule.SetUpdate2DButtonsPosJsCallBack(
        "resegmentationModule.SetUpdate2DButtonsPosJsCallBack",
      )
      console.log("SetUpdate2DButtonsPosJsCallBack successfully")
    }
  }
  Set2DButtonsVisiblityJsCallBack(callback: (isShow: boolean) => void) {
    const moduleManager = (wasmModule as any).moduleManager
    if (!wasmModule.isFinishedOpencase || !moduleManager) return
    this.wasmResegmentationModule = moduleManager.GetResegmentationModule()
    if (!(window as any).resegmentationModule) {
      ;(window as any).resegmentationModule = {}
    }
    ;(window as any).resegmentationModule.Set2DButtonsVisiblityJsCallBack = callback
    if (this.wasmResegmentationModule != null) {
      this.wasmResegmentationModule.Set2DButtonsVisiblityJsCallBack(
        "resegmentationModule.Set2DButtonsVisiblityJsCallBack",
      )
      console.log("Set2DButtonsVisiblityJsCallBack successfully")
    }
  }

}

export const resegmentationModule = new ResegmentationModule()
